// Copyright (c) StrangeBee 2024

import { Popconfirm, PopconfirmProps } from 'antd';
import React, { ReactElement } from 'react';

import './THPopConfirm.scss';

interface THPopConfirmProps extends PopconfirmProps {
    hiddenCancel?: boolean;
}

export const THPopConfirm = ({ hiddenCancel = false, ...props }: THPopConfirmProps): ReactElement => (
    <Popconfirm
        overlayClassName="th-pop-confirm"
        cancelButtonProps={{
            className: 'th-button ant-btn-link ant-btn-dangerous',
            hidden: hiddenCancel,
        }}
        okButtonProps={{
            className: 'th-button',
        }}
        {...props}
    />
);
